import * as React from 'react';
import { Box, IconButton, Popover, TextField } from '@mui/material';
import { Clear } from '@mui/icons-material';

import { IEnhancedTableTextFilter } from 'models';

export interface EnhancedTableTextFilterProps {
  anchorEl: HTMLButtonElement | null;
  anchorId: string;
  anchorLabel: string | React.ReactNode;
  textFilters: IEnhancedTableTextFilter;
  handleClose: () => void;
  updateText: (filterName: string, value: string) => void;
}

export const EnhancedTableTextFilter: React.FC<EnhancedTableTextFilterProps> = (props) => {
  const { anchorEl, anchorLabel, anchorId, textFilters, handleClose, updateText } = props;

  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          padding: 2,
        }}
      >
        <TextField
          label={anchorLabel}
          variant="outlined"
          fullWidth
          size="small"
          value={textFilters[anchorId]}
          onChange={(e) => {
            updateText(anchorId, e.target.value);
          }}
          sx={{
            width: 200,
          }}
        />
        <IconButton
          color="primary"
          size="small"
          onClick={() => {
            if (textFilters[anchorId]) {
              updateText(anchorId, '');
            } else {
              handleClose();
            }
          }}
          sx={{
            marginLeft: 1,
            marginRight: -1,
          }}
        >
          <Clear fontSize="small" />
        </IconButton>
      </Box>
    </Popover>
  );
};
